import Splide from '@splidejs/splide';
// スライダーの設定
const commonOption = {
  gap: 10,
  perMove: 1,
  pagination: false,
  speed: 500,
  dragMinThreshold: 15,
  mediaQuery: 'min',
  autoplay: true,
};

export const cardSlider = () => {
  // トレカのスライダー
  const bannerOption1 = {
    ...commonOption,
    fixedWidth: '74%',
    type: 'loop',

    breakpoints: {
      769: {
        perPage: 1,
        gap: 10,
        pagination: true,
        fixedWidth: '37%',
        speed: 600,
      },
    },
  };
  const bannerList = document.querySelectorAll('.js-cardBannerSlider1');
  if (bannerList.length > 0) {
    bannerList.forEach((el) => {
      new Splide(el, bannerOption1).mount();
    });
  }

  const bannerOption2 = {
    ...commonOption,
    type: 'loop',
    fixedWidth: '40%',
    gap: 16,

    breakpoints: {
      769: {
        gap: 10,
        fixedWidth: '13%',
        speed: 600,
      },
    },
  };
  if (document.getElementById('js-cardBannerSlider2')) {
    new Splide('#js-cardBannerSlider2', bannerOption2).mount();
  }

  const bannerOption3 = {
    ...commonOption,
    fixedWidth: '55%',
    type: 'loop',
    gap: 10,
    focus: 'center',

    breakpoints: {
      769: {
        perPage: 1,
        gap: 10,
        fixedWidth: '100%',
        speed: 600,
        height: '200px',
      },
    },
  };
  if (document.getElementById('js-cardBannerSlider3')) {
    new Splide('#js-cardBannerSlider3', bannerOption3).mount();
  }

  const productOption = {
    ...commonOption,
    autoplay: false,
    fixedWidth: '140px',

    breakpoints: {
      769: {
        perPage: 1,
        gap: 10,
        fixedWidth: '150px',
        speed: 600,
      },
    },
  };

  const cardProductList = document.querySelectorAll('.js-cardProductSlider');
  if (cardProductList.length > 0) {
    cardProductList.forEach((el) => {
      new Splide(el, productOption).mount();
    });
  }

  const historyOption = {
    ...commonOption,
    autoplay: false,
    fixedWidth: '80px',

    breakpoints: {
      769: {
        perPage: 1,
        gap: 10,
        fixedWidth: '120px',
        speed: 600,
      },
    },
  };
  if (document.getElementById('js-cardHistorySlider')) {
    new Splide('#js-cardHistorySlider', historyOption).mount();
  }
};

export const topSlider = () => {
  var topSplide1 = document.getElementById('js-topSplide1');
  if (topSplide1) {
    // トップページのバナー
    const bannerOption1 = {
      ...commonOption,
      type: 'loop',
      fixedWidth: '74%',
      focus: 'center',

      breakpoints: {
        769: {
          perPage: 1,
          gap: 25,
          pagination: true,
          fixedWidth: '25%',
          speed: 600,
        },
      },
    };
    new Splide('#js-topSplide1', bannerOption1).mount();
  }

  var topSplide2 = document.getElementById('js-topSplide2');
  if (topSplide1) {
    const bannerOption2 = {
      ...commonOption,
      fixedWidth: '25%',
      type: 'loop',
      gap: 10,

      breakpoints: {
        769: {
          perPage: 1,
          gap: 10,
          fixedWidth: '160px',
          speed: 600,
        },
      },
    };
    new Splide('#js-topSplide2', bannerOption2).mount();
  }
};

export const topProductSlider = () => {
  // TOPにある商品スライダー
  const productOption = {
    ...commonOption,
    autoplay: false,
    fixedWidth: '40%',

    breakpoints: {
      1000: {
        fixedWidth: 'calc((100% - 40px) / 5)',
        perMove: 5,
        gap: 10,
        speed: 600,
      },
      1400: {
        fixedWidth: 'calc((100% - 60px) / 7)',
        perMove: 7,
      },
    },
  };

  const topProductList = document.querySelectorAll('.js-topProductList');
  if (topProductList.length > 0) {
    topProductList.forEach((el) => {
      new Splide(el, productOption).mount();
    });
  }
};

export const productSlider = () => {
  const productOption = {
    ...commonOption,
    autoplay: false,
    fixedWidth: '40%',

    breakpoints: {
      769: {
        fixedWidth: 'calc((100% - 30px) / 4)',
        perMove: 4,
        gap: 10,
        speed: 600,
      },
    },
  };

  const topProductList = document.querySelectorAll('.js-productListSlide');
  if (topProductList.length > 0) {
    topProductList.forEach((el) => {
      new Splide(el, productOption).mount();
    });
  }
};

export const productSliderLarge = () => {
  const productOption = {
    ...commonOption,
    autoplay: false,
    fixedWidth: '40%',

    breakpoints: {
      769: {
        fixedWidth: 'calc((100% - 50px) / 6)',
        perMove: 6,
        gap: 10,
        speed: 600,
      },
    },
  };

  const topProductList = document.querySelectorAll('.js-productListSlideLarge');
  if (topProductList.length > 0) {
    topProductList.forEach((el) => {
      new Splide(el, productOption).mount();
    });
  }
};

// トレカ詳細のメインイメージスライダー
export const productMainImageSlider = () => {
  const productOption = {
    ...commonOption,
    autoplay: false,
    perPage: 1,
    focus: 'center',
    gap: 10,
    pagination: true,

    breakpoints: {
      769: {
        perPage: 1,
        gap: 10,
        speed: 600,
        pagination: false,
      },
    },
  };

  const topProductList = document.querySelectorAll('.js-productMainImageSlide');
  if (topProductList.length === 0) {
    return;
  }
  topProductList.forEach((el) => {
    const splide = new Splide(el, productOption);

    // リスト要素をクラス名ですべて取得
    const thumbnails = el.getElementsByClassName('splide__thumbnail');

    for (let i = 0; i < thumbnails.length; i++) {
      initThumbnail(thumbnails[i], i);
    }

    // それぞれのリスト要素を初期化するための関数
    function initThumbnail(thumbnail, index) {
      thumbnail.addEventListener('click', function () {
        splide.go(index);
      });
    }

    let current; // 現在のサムネイルを保持するための変数

    splide.on('mounted move', function () {
      const thumbnail = thumbnails[splide.index];

      if (thumbnail) {
        if (current) {
          current.classList.remove('is-active');
        }

        thumbnail.classList.add('is-active');
        current = thumbnail;
      }
    });
    splide.mount();
    // window.addEventListener('resize', () => {
    //   splide.refresh();
    // });
  });
};

// トレカ詳細のメインイメージモーダルスライダー
export const productMainImageModalSlider = () => {
  const productOption = {
    ...commonOption,
    autoplay: false,
    perPage: 1,
    focus: 'center',
    gap: 10,

    breakpoints: {
      769: {
        perPage: 1,
        gap: 10,
        speed: 600,
      },
    },
  };

  const thumbnailOption = {
    ...commonOption,
    type: 'slide',
    rewind: true,
    autoplay: false,
    perPage: 4,
    width: 270,
    gap: 10,
    isNavigation: true,
    breakpoints: {
      769: {
        width: 610,
        perPage: 6,
        speed: 600,
        gap: 10,
      },
    },
  };

  const topProductList = document.querySelectorAll('.js-productMainImageModalSlide');
  if (topProductList.length === 0) {
    return;
  }
  topProductList.forEach((el) => {
    const splide = new Splide(el, productOption);

    // リスト要素をクラス名ですべて取得
    const thumbnailsList = el.getElementsByClassName('js-productMainImageModalThumbnailSlide');
    const thumbnailsSplide = new Splide(thumbnailsList[0], thumbnailOption);

    thumbnailsSplide.on('overflow', function (isOverflow) {
      thumbnailsSplide.options = {
        arrows: isOverflow,
        drag: isOverflow,
      };
    });

    splide.sync(thumbnailsSplide);
    splide.mount();
    thumbnailsSplide.mount();
  });
};

// カテゴリートップ・ジャンルトップのスライダー
export const categorySlider = () => {
  const bannerElement = document.getElementById('js-categoryBanner');
  const topProductList = document.querySelectorAll('.js-categorySlider');

  // トップページのバナー
  if (bannerElement) {
    const bannerOption = {
      ...commonOption,
      type: 'loop',
      fixedWidth: '25%',
      gap: 10,
      breakpoints: {
        769: {
          perPage: 1,
          gap: 10,
          fixedWidth: '160px',
          speed: 600,
        },
      },
    };
    new Splide(bannerElement, bannerOption).mount();
  } else {
    console.warn('Banner element #js-categoryBanner not found.');
  }

  // 商品リストのスライダー
  if (topProductList.length > 0) {
    const productOption = {
      ...commonOption,
      autoplay: false,
      fixedWidth: '40%',
      breakpoints: {
        1000: {
          fixedWidth: 'calc((100% - 40px) / 5)',
          perMove: 5,
          gap: 10,
          speed: 600,
        },
        1400: {
          fixedWidth: 'calc((100% - 60px) / 7)',
          perMove: 7,
        },
      },
    };

    topProductList.forEach((el) => {
      if (el) {
        new Splide(el, productOption).mount();
      } else {
        console.warn('Product list element not found for .js-categorySlider');
      }
    });
  } else {
    console.warn('No elements found with the class .js-categorySlider.');
  }
};
